import { defineMessages } from 'react-intl'

const scope = `procurify.components.PunchOutOrderInfo`

export default defineMessages({
  defaultTitle: {
    id: `${scope}.defaultTitle`,
    defaultMessage: 'PunchOut Order',
  },
  partiallyPurchased: {
    id: `${scope}.partiallyPurchased`,
    defaultMessage: 'Partially Purchased',
  },
  orderCancelled: {
    id: `${scope}.orderCancelled`,
    defaultMessage: 'Order Canceled',
  },
  backordered: {
    id: `${scope}.backordered`,
    defaultMessage: 'Backordered',
  },
  backorderedPrompt: {
    id: `${scope}.backorderedPrompt`,
    defaultMessage:
      'This item is currently on backorder. Please contact vendor for further information.',
  },
  defaultPrompt: {
    id: `${scope}.defaultPrompt`,
    defaultMessage: 'Please notify the purchaser to replace your order.',
  },
  failedOrderTitle: {
    id: `${scope}.failedOrderTitle`,
    defaultMessage: 'Order failed',
  },
  failedOrderPrompt: {
    id: `${scope}.failedOrderPrompt`,
    defaultMessage:
      'Failed to send order to PunchOut vendor. Please try resending the PO.',
  },
})
